import * as yup from 'yup';

export const addEarningPlanSchema = yup.object().shape({
  productVariantId: yup.string().required('Earning plan is a required field')
});
